/* assets/infinite-scroll.js — Prestige <product-list>/<product-card> (compat) */
(function () {
  try {
    if (window.__INF_SCROLL_RUNNING__) return;
    window.__INF_SCROLL_RUNNING__ = true;

    if (!("IntersectionObserver" in window)) return;

    var log = function(){ try{ console.log.apply(console, ["[inf-scroll]"].concat([].slice.call(arguments))); }catch(e){} };

    // Track pages loaded (initial render counts as 1)
    var pagesLoaded = 1;
    window.__pagesLoaded = pagesLoaded;

    // 1) Main collection section
    var section = document.querySelector(".shopify-section--main-collection, .shopify-section.shopify-section--main-collection");
    if (!section) { log("No main collection section found"); return; }

    // 2) Product grid
    var grid = section.querySelector("product-list.product-list");
    if (!grid) { log("No product-list grid found"); return; }
    log("Grid found:", grid);

    // 3) Find next page URL
    var nextSel = "a[rel=next], .pagination__next a, a.pagination__next, .pagination a.next, nav.pagination a[rel=next]";
    var nextAnchor = section.querySelector(nextSel);
    var headNext = document.querySelector("link[rel=next]");
    var nextURL = nextAnchor ? (nextAnchor.href || nextAnchor.getAttribute("href")) : (headNext ? headNext.href : null);

    if (!nextURL) { log("No next page link found (single page)"); return; }
    log("Next URL:", nextURL);

    // Hide pagination if present
    var pagination = nextAnchor && nextAnchor.closest ? nextAnchor.closest(".pagination, nav.pagination") : null;
    if (pagination) pagination.style.display = "none";

    // 4) Sentinel
    var sentinel = document.getElementById("infinite-sentinel");
    if (!sentinel) {
      sentinel = document.createElement("div");
      sentinel.id = "infinite-sentinel";
      sentinel.style.cssText = "height:1px;width:100%;";
      grid.insertAdjacentElement("afterend", sentinel);
    }

    // 5) Append helper
    function appendFromDoc(doc) {
      var newSection =
        doc.querySelector(".shopify-section--main-collection") ||
        doc.querySelector(".shopify-section.shopify-section--main-collection") ||
        doc;

      var newGrid = newSection.querySelector("product-list.product-list");
      if (!newGrid) return { added: 0, next: null };

      var newProducts = Array.prototype.slice.call(newGrid.querySelectorAll("product-card"));
      newProducts.forEach(function (p) { grid.appendChild(p); });

      // reveal & nudge
      requestAnimationFrame(function () {
        newProducts.forEach(function (card) {
          card.classList.add("is-revealed");
          card.removeAttribute("reveal-on-scroll");
        });
        window.dispatchEvent(new Event("scroll"));
        window.dispatchEvent(new Event("resize"));
      });

      // find next
      var newNext =
        newSection.querySelector(nextSel) ||
        doc.querySelector(nextSel) ||
        doc.querySelector("link[rel=next]");
      var href = newNext ? (newNext.href || newNext.getAttribute("href")) : null;

      return { added: newProducts.length, next: href };
    }

    // 6) Loader (also exposed globally for restore)
    var loading = false;
    var io = null;

    async function loadNextPageOnce() {
      if (!nextURL || loading) return false;
      loading = true;
      try {
        var res = await fetch(nextURL, { credentials: "same-origin" });
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, "text/html");

        var result = appendFromDoc(doc);
        var added = result.added;
        var next = result.next;
        nextURL = next || null;

        if (added > 0) {
          pagesLoaded += 1;
          window.__pagesLoaded = pagesLoaded;
          try {
            document.dispatchEvent(new CustomEvent("collection:appended", { detail: { added: added } }));
          } catch(e) {}
          log("Appended " + added + " products (pagesLoaded=" + pagesLoaded + ")");
        }

        if (!nextURL) {
          if (io && io.disconnect) io.disconnect();
          log("No more pages");
        }
        return added > 0;
      } catch (err) {
        console.error("[inf-scroll] fetch error", err);
        if (io && io.disconnect) io.disconnect();
        return false;
      } finally {
        loading = false;
      }
    }
    window.__loadNextCollectionPage = loadNextPageOnce; // expose for restore

    // 7) Observer
    io = new IntersectionObserver(function (entries) {
      var seen = false;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { seen = true; break; }
      }
      if (!seen) return;
      // fire and forget
      loadNextPageOnce();
    }, { rootMargin: "800px 0px 800px 0px" });

    io.observe(sentinel);
    log("Infinite scroll active");
  } catch (e) {
    console.error("[inf-scroll] fatal", e);
  }
})();
